import React from "react";
import { Container } from "react-bootstrap";
import { useSelector } from "react-redux";
import { formatNumber } from "../Actions/commonFunction";

function DetailHeader() {
  const { headerData } = useSelector((state) => state.user);

  return (
    <div className="dash_header">
      <Container>
        <div className="d-flex alldash flex-wrap">
          <p className="mb-0 fw-600">
            Cryptos:{" "}
            <span className="themeclr">
              {formatNumber(headerData?.cryptos)}
            </span>
          </p>
          <p className="mb-0 fw-600">
            Exchanges:{" "}
            <span className="themeclr">
              {formatNumber(headerData?.exchanges)}
            </span>
          </p>
          <p className="mb-0 fw-600">
            Dominance BTC: <span className="themeclr">{headerData?.dominance?.Dominence?.find(val=>val.symbol == "BTC")?.dominance ?? "0"}%</span>
          </p>
          <p className="mb-0 fw-600">
            ETH: <span className="themeclr">{headerData?.dominance?.Dominence?.find(val=>val.symbol == "ETH")?.dominance ?? "0"}%</span>
          </p>
          {/* <p className="mb-0 fw-600">
            Stable coins: <span className="themeclr">12.2%</span>
          </p> */}
          <p className="mb-0 fw-600">
            SOL: <span className="themeclr">{headerData?.dominance?.Dominence?.find(val=>val.symbol == "SOL")?.dominance ?? "0"}%</span>
          </p>
          {/* <p className="mb-0 fw-600">
            EDA: <span className="themeclr">0.1%</span>
          </p> */}
          <p className="mb-0 fw-600">
            Fear & greed: <span className="themeclr">40/100</span>
          </p>
          <p className="mb-0 fw-600">Most Visited </p>
          <p className="mb-0 fw-600">Trending On Dexscan </p>
        </div>
      </Container>
    </div>
  );
}

export default DetailHeader;
